import { createContext } from 'react';

const CategoriesContext = createContext({});
export default CategoriesContext;
